import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsInvalidFiscalRegime extends AnnualPeriodsError {
    fiscalRegime;
    constructor(fiscalRegime, options) {
        super('Fiscal regime code is not valid', options);
        this.fiscalRegime = fiscalRegime;
    }
}
export default AnnualPeriodsInvalidFiscalRegime;
